import React from 'react';
import {Redirect, Route, Switch} from 'react-router-dom';
import list from './list';
import info from './info';

const Users = ({match}) => (
  <div className="dashboard-wrapper">
    <Switch>
      <Redirect exact from={`${match.url}/`} to={`${match.url}/list`}/>
      <Route path={`${match.url}/list`} component={list}/>
      <Route path={`${match.url}/:id`} component={info}/>
      <Redirect to="/error"/>
    </Switch>
  </div>
);
export default Users;
